export default "__VITE_ASSET__24d877b6__"